import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";

// Actions
import {
  setView,
  discardStudy,
  setCreateProtocolMode,
  toggleSaveDialog,
  setSaveAndQuit,
} from "../../actions";

// MUI Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
// Images
import logo from "../../images/microelastic_words_and_logo_bold.png";

// Icons
import ArrowBack from "@material-ui/icons/ArrowBack";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";

// Other
import { colors } from "../../constants/colors";
import { viewIds } from "../../constants/componentMap";
import HeaderMenu from "./HeaderMenu";
import { customTheme } from "../../constants/customTheme";

const useStyles = makeStyles({
  root: {
    backgroundColor: (props) => colors[props.theme].headerBkg,
    flex: "0 0 auto",
    zIndex: 2,
    height: "35px",
  },
  rootMain: {
    // Hovering menu
    backgroundColor: (props) => colors[props.theme].headerBkg,
    height: "35px",
    width: "60%",
    display: "flex",
    zIndex: "1000",
    position: "fixed",
    right: "0%",
    alignItems: "center",
  },
  headerItem: {
    flex: "1 0 33%",
  },
  right: {
    paddingRight: "10px",
    paddingLeft: "20px",
  },
  progressBar: {
    backgroundColor: (props) => colors[props.theme].progressBarBkgHeader,
    borderRadius: "4px",
    height: "10px",
    flex: "0 0 40%",
    margin: "5px",
  },
  logo: {
    margin: "5px",
    marginLeft: "14px",
  },
  studyName: {
    fontSize: "1.2rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft: "36px",
  },
  protocolName: {
    fontSize: "1.2rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  button: {
    textTransform: "none",
    padding: "6px 16px",
  },
  progressContainer: {
    marginRight: "10px",
  },
  buttonPrimary: (props) => ({
    ...customTheme(props.theme).buttonPrimary,
    padding: "0px 5px 0px 5px",
    marginRight: "5px",
    textTransform: "none",
  }),
});

const Header = (props) => {
  const classes = useStyles(props);

  // window
  //   .require("electron")
  //   .remote.getCurrentWindow()
  //   .setMenuBarVisibility(true);

  if (props.view !== viewIds.mainApp) {
    // SIMPLE HEADER
    return (
      <Grid
        item
        container
        className={classes.root + " draggable"}
        justify="space-between"
        alignItems="center"
        wrap="nowrap"
      >
        {/* LEFT */}
        <Grid
          item
          container
          className={classes.headerItem}
          justify="flex-start"
        >
          {/* Back Arrow */}
          {(props.view === viewIds.newStudy ||
            props.view === viewIds.loadStudy ||
            props.view === viewIds.loadParticipantReview ||
            props.view === viewIds.customProtocol ||
            props.view === viewIds.reviewMode) && (
            <IconButton
              className={classes.button}
              onClick={() => {
                props.setCreateProtocolMode(false);
                props.discardStudy("QUIT");
                props.setView(viewIds.startPage);
              }}
            >
              <ArrowBack />
            </IconButton>
          )}
        </Grid>
        <Grid item container className={classes.headerItem} justify="center">
          {props.view === viewIds.reviewMode ? (
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.studyName}
            >
              Participant ID: {props.participantId}
            </Typography>
          ) : (
            <img
              src={logo}
              height="30px"
              className={classes.logo}
              alt="MicroElastic logo"
            />
          )}
        </Grid>
        <Grid item container className={classes.headerItem} justify="flex-end">
          {props.view !== viewIds.loginPage && (
            //  ? (
            //   <Button
            //     className={classes.button}
            // onClick={() => {
            //   if (
            //     window.require("electron").remote.process.platform === "win32"
            //   ) {
            //     window.require("electron").remote.getCurrentWindow().close();
            //   } else if (
            //     window.require("electron").remote.process.platform === "linux"
            //   ) {
            //     const { exec } = window.require("child_process");
            //     exec("sudo shutdown -h now", (error, data, getter) => {
            //       console.log(data, getter);
            //     });
            //   }
            // }}
            //     startIcon={<PowerSettingsNewIcon />}
            //   >
            //     Exit App
            //     {/* {window.require("electron").remote.process.platform === "linux"
            //       ? "Shut Down"
            //       : "Exit App"} */}
            //   </Button>
            // ) : (
            <HeaderMenu
            // eventSource={props.eventSource}
            />
          )}
        </Grid>
      </Grid>
    );
  } else {
    // MAIN APP HEADER
    return (
      <Grid
        item
        container
        className={classes.rootMain + " draggable"}
        direction="column"
        wrap="nowrap"
      >
        {/* HEADER */}
        <Grid
          item
          container
          className={classes.rootMain + " draggable"}
          justify="space-between"
          alignItems="center"
          wrap="nowrap"
        >
          {/* CENTER */}
          <Grid
            item
            container
            className={classes.headerItem}
            style={{ minWidth: 0 }}
          >
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.studyName}
            >
              {props.protocolName}
            </Typography>
          </Grid>

          {/* RIGHT */}
          <Grid
            item
            container
            wrap="nowrap"
            className={classNames(classes.headerItem, classes.right)}
            alignItems="center"
            justify="flex-end"
          >
            {/* STUDY PROGRESS */}
            {props.totalSamplesNeeded > 0 && props.progress !== 100 ? (
              <React.Fragment>
                <Typography display="inline" variant="body2">
                  Progress
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={props.progress}
                  className={classes.progressBar}
                />
                <Typography
                  className={classes.progressContainer}
                  display="inline"
                  variant="body2"
                >
                  {props.progress}%
                </Typography>
              </React.Fragment>
            ) : (
              props.totalSamplesNeeded > 0 &&
              props.progress === 100 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    props.discardStudy("QUIT");
                    // props.setSaveAndQuit(true);
                    // props.toggleSaveDialog();
                  }}
                  className={classes.buttonPrimary}
                  disabled={props.disableButton}
                >
                  Save & Quit
                </Button>
              )
            )}

            {/* HEADER MENU */}
            <HeaderMenu />
          </Grid>
        </Grid>
      </Grid>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setView,
      discardStudy,
      setCreateProtocolMode,
      toggleSaveDialog,
      setSaveAndQuit,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    progress: state.studyInfo.progress,
    totalSamplesNeeded: state.studyInfo.totalSamplesNeeded,
    protocolName: state.studyInfo.protocolName,
    view: state.view.viewId,
    participantId: state.availableParticipants.selectedParticipantId,
    disableButton:
      state.device.acquiring ||
      !state.utility.samplesDone ||
      !state.utility.samplesSaved,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
